<template>
  <div v-if="producer.contacts" class="ui segment">
    <div class="ui top attached label">
      <i class="users icon"></i>Contacts :
    </div>
    <div v-for="(contact, index) in producer.contacts" :key="index">
      <div class="ui segment">
        <div class="ui top left attached label">{{contact.role}}</div>
        <div v-if="contact.name != null">{{getI18n(contact.name,"en")}}</div>
        <div v-if="contact.acronym != null">{{contact.acronym}}</div>
        <div>
          <span v-if="contact.firstName != null">{{contact.firstName}}</span>
          <span v-if="contact.lastName != null">{{contact.lastName}}</span>
        </div>
        <div v-if="contact.email != null">{{contact.email}}</div>
        <div v-if="contact.orcId != null">{{contact.orcId}}</div>
        <div v-if="contact.organisation != null">
          <div class="ui segment">
            <div class="ui top left attached label">{{contact.organisation.role}}</div>
            <div
              v-if="contact.organisation.name != null"
            >{{getI18n(contact.organisation.name,"en")}}</div>
            <div v-if="contact.organisation.acronym != null">{{contact.organisation.acronym}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["producer"],
  methods: {
    /**
     * Getter to get the value according the the internationalisation
     */
    getI18n(el, lang) {
      let tmp = el.find(element => element.lang === lang);
      return tmp.text;
    }
  }
};
</script>

<style>
</style>
